export const API_URL = 'buffers/incidentType'
export const ROUTE_NAME = 'buffers/incidentType'
